
import { defineComponent } from 'vue';
import CarouselComp from '@/Components/carouselComp.vue';

export default defineComponent({
    data: function () {
        return {};
    },
    components: { CarouselComp }
})
    
